// Common UI translations
const dictUI = {
    // Common UI text
    comments: {
        th: "ความคิดเห็น",
        en: "Comments",
        ja: "コメント",
    },
    likes: {
        th: "ถูกใจ",
        en: "Likes",
        ja: "いいね",
    },
    views: {
        th: "การดู",
        en: "Views",
        ja: "閲覧数",
    },
    read_count: {
        th: "จำนวนผู้อ่าน",
        en: "Read Count",
        ja: "既読数",
    },
    read_more: {
        th: "อ่านเพิ่มเติม",
        en: "Read More",
        ja: "もっと読む",
    },
    // Mobile hamburger-drawer "Settings" entry — the header's own gear icon
    // is hidden on mobile; this drawer row replaces it, opening the same
    // settings popover (zoom toggle / language / social connections).
    settings: {
        th: "การตั้งค่า",
        en: "Settings",
        ja: "設定",
    },
    // "admin" label beside the desktop nav bar's admin/editor-only full-text
    // search icon (ISS-04-094) — distinguishes it from the regular catalog
    // search icon beside it. Mobile hides this search entirely, so no
    // mobile-specific wording is needed here.
    navbar_admin_search_label: {
        th: "admin",
        en: "admin",
        ja: "admin",
    },
    ogp_preview_limit_warning: {
        th: "ตรวจพบ URL จำนวน {{totalUrls}} รายการ แต่จะแสดงพรีวิวเฉพาะ {{maxUrls}} รายการแรกเท่านั้น",
        en: "{{totalUrls}} URLs were detected, but only the first {{maxUrls}} preview(s) will be shown.",
        ja: "{{totalUrls}}個のURLが検出されましたが、プレビューは最初の{{maxUrls}}件のみ表示されます。",
    },
    back_to_list: {
        th: "กลับไปรายการ",
        en: "Back to List",
        ja: "リストに戻る",
    },
    edit: {
        th: "แก้ไข",
        en: "Edit",
        ja: "編集",
    },
    created_by: {
        th: "สร้างโดย (user_id)",
        en: "Created by (user_id)",
        ja: "作成者（user_id）",
    },
    updated_by: {
        th: "อัปเดตโดย (user_id)",
        en: "Updated by (user_id)",
        ja: "更新者（user_id）",
    },
    created_at: {
        th: "สร้างเมื่อ",
        en: "Created at",
        ja: "作成日時",
    },
    updated_at: {
        th: "อัปเดตเมื่อ",
        en: "Updated at",
        ja: "更新日時",
    },
    delete: {
        th: "ลบ",
        en: "Delete",
        ja: "削除",
    },
    merge: {
        th: "รวม",
        en: "Merge",
        ja: "統合",
    },
    merge_tool_title: {
        th: "เครื่องมือรวมข้อมูล",
        en: "Merge",
        ja: "統合ツール",
    },
    merge_tool_no_candidates: {
        th: "ไม่พบรายการที่สามารถรวมได้จากบันทึกของรายการนี้",
        en: "No merge candidates were auto-detected from this entity's note.",
        ja: "このエンティティのノートから統合先候補を自動検出できませんでした。",
    },
    merge_tool_source_label: {
        th: "ต้นทาง",
        en: "Source",
        ja: "統合元",
    },
    merge_tool_target_label: {
        th: "ปลายทาง",
        en: "Target",
        ja: "統合先",
    },
    save: {
        th: "บันทึก",
        en: "Save",
        ja: "保存",
    },
    cancel: {
        th: "ยกเลิก",
        en: "Cancel",
        ja: "キャンセル",
    },
    check: {
        th: "ตรวจสอบ",
        en: "Check",
        ja: "チェック",
    },
    upload: {
        th: "อัปโหลด",
        en: "Upload",
        ja: "アップロード",
    },
    ok: {
        th: "ตกลง",
        en: "OK",
        ja: "OK",
    },
    confirm: {
        th: "ยืนยัน",
        en: "Confirm",
        ja: "確認",
    },
    search: {
        th: "ค้นหา",
        en: "Search",
        ja: "検索",
    },
    admin_search: {
        th: "ค้นหา (แอดมิน)",
        en: "Admin Search",
        ja: "管理者検索",
    },
    target_product_search: {
        th: "ค้นหาสินค้าเป้าหมาย",
        en: "Target Product Search",
        ja: "対象商品検索",
    },
    clear: {
        th: "ล้าง",
        en: "Clear",
        ja: "クリア",
    },
    menu: {
        th: "เมนู",
        en: "Menu",
        ja: "メニュー",
    },
    close: {
        th: "ปิด",
        en: "Close",
        ja: "閉じる",
    },
    breadcrumb: {
        th: "เส้นทางนำทาง",
        en: "Breadcrumb",
        ja: "パンくずリスト",
    },
    home: {
        th: "หน้าแรก",
        en: "Home",
        ja: "ホーム",
    },
    about_us: {
        th: "เกี่ยวกับ Vanilla",
        en: "About Us",
        ja: "About Us",
    },
    about_us_sections: {
        th: "หัวข้อ About Us",
        en: "About Us sections",
        ja: "About Us セクション",
    },
    about_vanilla: {
        th: "เกี่ยวกับ Vanilla",
        en: "About Vanilla",
        ja: "Vanilla について",
    },
    review_guidelines: {
        th: "แนวทางการรีวิว",
        en: "Review Guidelines",
        ja: "レビューガイドライン",
    },
    terms_of_use: {
        th: "ข้อกำหนดการใช้งาน",
        en: "Terms Of Use",
        ja: "利用規約",
    },
    terms_of_service: {
        th: "ข้อกำหนดการให้บริการ",
        en: "Terms of Service",
        ja: "利用規約",
    },
    privacy_policy: {
        th: "นโยบายความเป็นส่วนตัว",
        en: "Privacy Policy",
        ja: "プライバシーポリシー",
    },
    contact_us: {
        th: "ติดต่อเรา",
        en: "Contact Us",
        ja: "お問い合わせ",
    },
    facebook_messenger_chat: {
        th: "แชทผ่าน Messenger",
        en: "Chat on Messenger",
        ja: "Messengerでチャット",
    },
    set: {
        th: "ตั้งค่า",
        en: "Set",
        ja: "セット",
    },
    remove: {
        th: "ลบ",
        en: "Remove",
        ja: "解除",
    },
    remove_all: {
        th: "ลบทั้งหมด",
        en: "Remove All",
        ja: "すべて解除",
    },
    no_data: {
        th: "ไม่มีข้อมูล",
        en: "No data",
        ja: "データがありません",
    },
    entity_brand: {
        th: "แบรนด์",
        en: "Brand",
        ja: "ブランド",
    },
    entity_product: {
        th: "สินค้า",
        en: "Product",
        ja: "商品",
    },
    entity_category: {
        th: "หมวดหมู่",
        en: "Category",
        ja: "カテゴリ",
    },
    entity_review: {
        th: "รีวิว",
        en: "Review",
        ja: "レビュー",
    },
    entity_user: {
        th: "ผู้ใช้",
        en: "User",
        ja: "ユーザ",
    },
    entity_post: {
        th: "โพสต์",
        en: "Post",
        ja: "投稿",
    },
    export_download: {
        th: "ส่งออก",
        en: "Export",
        ja: "エクスポート",
    },
    export_offline_latest: {
        th: "ไฟล์ที่สร้างไว้ล่วงหน้า (ล่าสุด)",
        en: "Latest pre-generated file",
        ja: "最新のオフライン生成ファイル",
    },
    export_offline_hint: {
        th: "ไฟล์ขนาดใหญ่จะถูกสร้างเบื้องหลังและพร้อมให้ดาวน์โหลดภายใน 1-2 นาที",
        en: "Large files are built in the background and ready to download within 1-2 minutes",
        ja: "大きなファイルはバックグラウンドで生成され、1〜2分でダウンロードできます",
    },
    export_status_pending: {
        th: "อยู่ในคิว จะเริ่มสร้างภายใน 1 นาที",
        en: "Queued — generation starts within a minute",
        ja: "キュー投入済み（1分以内に生成開始）",
    },
    export_status_running: {
        th: "กำลังสร้างไฟล์…",
        en: "Generating file…",
        ja: "ファイルを生成中…",
    },
    export_status_ready: {
        th: "ไฟล์พร้อมแล้ว",
        en: "File ready",
        ja: "ファイル準備完了",
    },
    export_status_slow: {
        th: "ยังสร้างไฟล์อยู่ กรุณากลับมาโหลดหน้านี้ใหม่ในภายหลัง",
        en: "Still generating — reload this page later to get the file",
        ja: "まだ生成中です。後でこのページを再読み込みしてください",
    },
    export_status_failed: {
        th: "สร้างไฟล์ไม่สำเร็จ กรุณาลองอีกครั้ง",
        en: "Export failed — please try again",
        ja: "エクスポートに失敗しました。もう一度お試しください",
    },
    export_status_download: {
        th: "ดาวน์โหลดไฟล์",
        en: "Download file",
        ja: "ファイルをダウンロード",
    },
    export_section_title: {
        th: "ส่งออก",
        en: "Export",
        ja: "エクスポート",
    },
    import_section_title: {
        th: "นำเข้า",
        en: "Import",
        ja: "インポート",
    },
    export_desc_default: {
        th: "กรุณาดาวน์โหลดเพื่อตรวจสอบรายละเอียด",
        en: "Download the file to see the details.",
        ja: "ダウンロードして内容をご確認ください。",
    },
    export_desc_category: {
        th: "รวม Review Question กรุณาดาวน์โหลดเพื่อตรวจสอบรายละเอียด",
        en: "Includes Review Questions. Download the file to see the details.",
        ja: "Review Question を含みます。ダウンロードして内容をご確認ください。",
    },
    import_desc_brands: {
        th: "อัปเดตแบรนด์ที่มีอยู่ หรือเพิ่มแบรนด์ใหม่",
        en: "Updates existing brands, or creates new ones.",
        ja: "既存ブランドを更新、または新規作成します。",
    },
    import_desc_categories: {
        th: "อัปเดตหมวดหมู่และคำถามรีวิวที่มีอยู่แล้วเท่านั้น",
        en: "Updates existing categories and review questions only.",
        ja: "既存のカテゴリ・レビュー質問のみ更新します。",
    },
    import_desc_products: {
        th: "อัปเดตสินค้าที่มีอยู่ หรือเพิ่มสินค้าใหม่",
        en: "Updates existing products, or creates new ones.",
        ja: "既存商品を更新、または新規作成します。",
    },
    import_desc_users: {
        th: "อัปเดตผู้ใช้ที่มีอยู่ หรือเพิ่มผู้ใช้ใหม่",
        en: "Updates existing users, or creates new ones.",
        ja: "既存ユーザーを更新、または新規作成します。",
    },
    import_desc_posts: {
        th: "อัปเดตโพสต์ที่มีอยู่ หรือเพิ่มโพสต์ใหม่",
        en: "Updates existing posts, or creates new ones.",
        ja: "既存投稿を更新、または新規作成します。",
    },
    import_req_category_id: {
        th: "ต้องระบุ category_id",
        en: "category_id required",
        ja: "category_id 必須",
    },
    import_req_brand_id: {
        th: "เว้นว่าง brand_id เพื่อสร้างใหม่อัตโนมัติ",
        en: "Leave brand_id blank to auto-create a new brand",
        ja: "brand_idを空欄にすると新規作成(自動採番)",
    },
    import_req_product_id: {
        th: "เว้นว่าง product_id เพื่อสร้างใหม่อัตโนมัติ",
        en: "Leave product_id blank to auto-create a new product",
        ja: "product_idを空欄にすると新規作成(自動採番)",
    },
    import_req_user_id: {
        th: "เว้นว่าง user_id เพื่อสร้างใหม่อัตโนมัติ",
        en: "Leave user_id blank to auto-create a new user",
        ja: "user_idを空欄にすると新規作成(自動採番)",
    },
    import_req_post_id: {
        th: "เว้นว่าง post_id เพื่อสร้างใหม่อัตโนมัติ",
        en: "Leave post_id blank to auto-create a new post",
        ja: "post_idを空欄にすると新規作成(自動採番)",
    },
    import_note_categories_no_create: {
        th: "ไม่สามารถสร้างหมวดหมู่หรือคำถามใหม่ได้",
        en: "Cannot create new categories or questions",
        ja: "新規カテゴリ/質問の作成はできません",
    },
    import_note_brands_duplicate_name: {
        th: "ชื่อแบรนด์ที่ซ้ำกันจะถูกปฏิเสธ",
        en: "Duplicate brand names are rejected",
        ja: "重複するブランド名はエラーになります",
    },
    import_note_brands_create_requires_name: {
        th: "การสร้างใหม่ต้องระบุ brand_name",
        en: "Creating a new brand requires brand_name",
        ja: "新規作成にはbrand_nameが必須",
    },
    import_note_images_zip: {
        th: "แนบไฟล์ ZIP รูปภาพได้ (ไม่บังคับ) เฉพาะไฟล์ที่ชื่อตรงกับคอลัมน์รูปภาพเท่านั้นจะถูกบันทึก",
        en: "An images ZIP is optional — only files whose name matches the image column are saved",
        ja: "画像ZIPは任意添付 — 画像列のファイル名と一致するものだけ保存されます",
    },
    import_brands_replace_mode_label: {
        th: "ลบแบรนด์ที่ไม่มีในไฟล์",
        en: "Delete brands not in file",
        ja: "ファイルにないブランドを削除(洗い替え)",
    },
    import_note_brands_replace_mode: {
        th: "หากเปิดใช้งาน แบรนด์ที่ไม่มีในไฟล์นี้จะถูกลบ ยกเว้นแบรนด์ที่ยังมีสินค้าอยู่จะไม่ถูกลบและขึ้นข้อผิดพลาดแทน",
        en: "When enabled, any brand missing from this file is deleted — brands that still have products are refused (error) instead of deleted",
        ja: "有効にすると、このファイルにないブランドは削除されます。ただし商品が存在するブランドは削除されずエラーになります",
    },
    import_images_zip_label: {
        th: "ไฟล์ภาพ (ZIP, ไม่บังคับ)",
        en: "Images (ZIP, optional)",
        ja: "画像 (ZIP、任意)",
    },
    import_note_products_create_requires_name: {
        th: "การสร้างใหม่ต้องระบุ product_name (ชื่อซ้ำจะถูกปฏิเสธ)",
        en: "Creating a new product requires product_name (duplicate names are rejected)",
        ja: "新規作成にはproduct_nameが必須(重複名はエラー)",
    },
    import_note_users_no_password: {
        th: "ไม่สามารถเปลี่ยนรหัสผ่านได้",
        en: "Passwords cannot be changed this way",
        ja: "パスワードは変更できません",
    },
    import_note_users_create_requires_identity: {
        th: "การสร้างใหม่ต้องระบุ nick_name, full_name, email, phone ครบทุกช่อง",
        en: "Creating a new user requires nick_name, full_name, email, and phone (all four)",
        ja: "新規作成にはnick_name/full_name/email/phoneが全て必須",
    },
    import_note_posts_no_board_change: {
        th: "ไม่สามารถเปลี่ยนบอร์ดของโพสต์เดิมได้",
        en: "An existing post's board cannot be changed this way",
        ja: "既存投稿のboard_idは更新では変更できません",
    },
    import_note_posts_create_requires_fields: {
        th: "การสร้างใหม่ต้องระบุ board_id, user_id, post_product_id, created_at",
        en: "Creating a new post requires board_id, user_id, post_product_id, and created_at",
        ja: "新規作成にはboard_id/user_id/post_product_id/created_atが必須",
    },
    import_file_label: {
        th: "ไฟล์ Excel (XLSX) หรือ JSON",
        en: "Excel (XLSX) or JSON file",
        ja: "Excel (XLSX) または JSON ファイル",
    },
    import_run: {
        th: "นำเข้า",
        en: "Import",
        ja: "インポート",
    },
    export_format_label: {
        th: "รูปแบบ",
        en: "Format",
        ja: "フォーマット",
    },
    export_users_status_label: {
        th: "สถานะผู้ใช้",
        en: "User status",
        ja: "ユーザーステータス",
    },
    export_users_status_all: {
        th: "ทั้งหมด (ไม่รวม dummy)",
        en: "All (excluding dummy)",
        ja: "すべて(dummyを除く)",
    },
    export_products_status_label: {
        th: "สถานะสินค้า",
        en: "Product status",
        ja: "商品ステータス",
    },
    export_products_status_all: {
        th: "ทั้งหมด (ไม่รวม brand)",
        en: "All (excluding brand)",
        ja: "すべて（brand を除く）",
    },
    export_posts_board_id_label: {
        th: "เลือกบอร์ด",
        en: "Select board",
        ja: "ボードを選択",
    },
    export_posts_status_label: {
        th: "สถานะโพสต์",
        en: "Post status",
        ja: "投稿ステータス",
    },
    export_posts_status_all: {
        th: "ทั้งหมด",
        en: "All",
        ja: "すべて",
    },
    export_posts_include_review_questions_label: {
        th: "รวมรหัสคำถาม (review)",
        en: "Include review question IDs",
        ja: "レビュー質問IDを含める",
    },
    monthly_rankings: {
        th: "อันดับประจำเดือน",
        en: "Monthly Rankings",
        ja: "月間ランキング",
    },
    search_category_search: {
        th: "หมวดหมู่",
        en: "Category",
        ja: "カテゴリ",
    },
    all_categories: {
        th: "ทั้งหมด",
        en: "All",
        ja: "すべて",
    },
    filter_keyword_search: {
        th: "ค้นหาคำสำคัญ...",
        en: "Search keywords...",
        ja: "キーワード検索...",
    },
    filter_category_placeholder: {
        th: "กรองหมวดหมู่...",
        en: "Filter categories...",
        ja: "カテゴリで絞り込む...",
    },
    category_review_editor_title: {
        th: "แก้ไขหมวดหมู่และคำถามรีวิว",
        en: "Category and Review Question Editor",
        ja: "カテゴリ・レビュー質問編集",
    },
    category_review_editor_tab_category: {
        th: "แก้ไขหมวดหมู่",
        en: "Category Edit",
        ja: "カテゴリ編集",
    },
    category_review_editor_tab_question: {
        th: "แก้ไขคำถาม",
        en: "Question Edit",
        ja: "質問編集",
    },
    category_review_editor_tab_parent: {
        th: "หมวดหมู่หลัก",
        en: "Parent Categories",
        ja: "親カテゴリ",
    },
    category_review_editor_tab_child: {
        th: "หมวดหมู่ย่อย",
        en: "Child Categories",
        ja: "子カテゴリ",
    },
    category_review_editor_tab_review: {
        th: "คำถามรีวิว",
        en: "Review Questions",
        ja: "レビュー質問",
    },
    category_review_editor_parent_category_id: {
        th: "Parent Category ID",
        en: "Parent Category ID",
        ja: "Parent Category ID",
    },
    category_review_editor_parent_category_name: {
        th: "Parent Category Name",
        en: "Parent Category Name",
        ja: "Parent Category Name",
    },
    category_review_editor_child_category_id: {
        th: "Child Category ID",
        en: "Child Category ID",
        ja: "Child Category ID",
    },
    category_review_editor_child_category_name: {
        th: "Child Category Name",
        en: "Child Category Name",
        ja: "Child Category Name",
    },
    category_review_editor_review_config_id: {
        th: "Questions",
        en: "Questions",
        ja: "Questions",
    },
    category_review_editor_item_count: {
        th: "Item Count",
        en: "Item Count",
        ja: "商品数",
    },
    category_review_editor_actions: {
        th: "Actions",
        en: "Actions",
        ja: "操作",
    },
    category_review_editor_status: {
        th: "Status",
        en: "Status",
        ja: "状態",
    },
    category_review_editor_parent_category_filter: {
        th: "Parent Category",
        en: "Parent Category",
        ja: "親カテゴリ",
    },
    category_review_editor_no_data: {
        th: "ไม่มีข้อมูล",
        en: "No data",
        ja: "データがありません",
    },
    category_review_editor_status_loading: {
        th: "กำลังโหลด...",
        en: "Loading...",
        ja: "読み込み中...",
    },
    processing: {
        th: "กำลังดำเนินการ...",
        en: "Processing...",
        ja: "処理中...",
    },
    jobs_dashboard_load_failed: {
        th: "โหลดรายการงานไม่สำเร็จ",
        en: "Failed to load jobs",
        ja: "ジョブの読み込みに失敗しました",
    },
    jobs_dashboard_run_all_finished: {
        th: "รันงานทั้งหมดเสร็จสิ้น",
        en: "Run all finished",
        ja: "全ジョブの実行が完了しました",
    },
    jobs_dashboard_run_all_finished_with_failures: {
        th: "รันงานทั้งหมดเสร็จสิ้น แต่มีงานล้มเหลว",
        en: "Run all finished with failures",
        ja: "全ジョブの実行は完了しましたが、一部失敗しました",
    },
    jobs_dashboard_invalid_schedule_type: {
        th: "ประเภท schedule ไม่ถูกต้อง",
        en: "Invalid schedule type",
        ja: "スケジュール種別が不正です",
    },
    jobs_dashboard_invalid_schedule_time: {
        th: "ต้องระบุเวลาในรูปแบบ HH:MM",
        en: "Schedule time is required in HH:MM format",
        ja: "スケジュール時刻は HH:MM 形式で指定してください",
    },
    jobs_dashboard_invalid_schedule_day: {
        th: "งานรายเดือนต้องระบุวันที่ 1 ถึง 31",
        en: "Monthly jobs require a day between 1 and 31",
        ja: "月次ジョブは 1 から 31 の日付が必要です",
    },
    jobs_dashboard_saved: {
        th: "บันทึกงานแล้ว",
        en: "Job saved",
        ja: "ジョブを保存しました",
    },
    jobs_dashboard_save_failed: {
        th: "บันทึกงานไม่สำเร็จ",
        en: "Failed to save job",
        ja: "ジョブの保存に失敗しました",
    },
    jobs_dashboard_job_execution_queued: {
        th: "เพิ่มงานเข้าคิวแล้ว",
        en: "Job execution queued",
        ja: "ジョブをキューに追加しました",
    },
    jobs_dashboard_run_failed: {
        th: "รันงานไม่สำเร็จ",
        en: "Failed to run job",
        ja: "ジョブの実行に失敗しました",
    },
    jobs_dashboard_aborted: {
        th: "ยกเลิกงานแล้ว",
        en: "Job aborted",
        ja: "ジョブを中断しました",
    },
    jobs_dashboard_failed_to_abort: {
        th: "ยกเลิกงานไม่สำเร็จ",
        en: "Failed to abort job",
        ja: "ジョブの中断に失敗しました",
    },
    jobs_dashboard_job_not_running: {
        th: "งานนี้ไม่ได้กำลังรันอยู่",
        en: "Job is not running",
        ja: "このジョブは実行中ではありません",
    },
    jobs_dashboard_running_process_not_tracked: {
        th: "กำลังรันอยู่แต่ไม่พบ process ที่ติดตามไว้",
        en: "Running process is not tracked",
        ja: "実行中プロセスの追跡情報が見つかりません",
    },
    jobs_dashboard_abort_conflict: {
        th: "สถานะงานเปลี่ยนไปแล้ว โปรดรีเฟรชรายการ",
        en: "Job state changed. Refreshing the list.",
        ja: "ジョブ状態が変わったため、一覧を更新します",
    },
    jobs_dashboard_finished: {
        th: "งานเสร็จสิ้นแล้ว",
        en: "Finished",
        ja: "完了しました",
    },
    jobs_dashboard_failed: {
        th: "งานล้มเหลว",
        en: "Failed",
        ja: "失敗しました",
    },
    admin_dashboard: {
        th: "แดชบอร์ด",
        en: "Dashboard",
        ja: "ダッシュボード",
    },
    admin_dashboard_daily: {
        th: "รายวัน",
        en: "Daily",
        ja: "日次",
    },
    admin_dashboard_monthly: {
        th: "รายเดือน",
        en: "Monthly",
        ja: "月次",
    },
    admin_dashboard_view_all: {
        th: "ดูทั้งหมด",
        en: "View all",
        ja: "すべて見る",
    },
    admin_dashboard_review_no_brand_no_product: {
        th: "รีวิวที่ไม่มีแบรนด์/สินค้า (product_id=0)",
        en: "Reviews with no brand/product (product_id=0)",
        ja: "ブランド/商品なしのレビュー(product_id=0)",
    },
    admin_dashboard_review_with_brand_no_product: {
        th: "รีวิวที่มีแบรนด์แต่ไม่มีสินค้าเฉพาะ",
        en: "Reviews with a brand but no specific product",
        ja: "ブランドはあるが商品が特定されていないレビュー",
    },
    admin_dashboard_day_over_day: {
        th: "เทียบวันก่อนหน้า",
        en: "vs yesterday",
        ja: "前日比",
    },
    admin_dashboard_brands: {
        th: "แบรนด์",
        en: "Brands",
        ja: "ブランド",
    },
    admin_dashboard_products: {
        th: "สินค้า",
        en: "Products",
        ja: "商品",
    },
    admin_dashboard_users: {
        th: "ผู้ใช้",
        en: "Users",
        ja: "ユーザー",
    },
    admin_dashboard_tiktoks: {
        th: "TikTok",
        en: "TikTok",
        ja: "TikTok",
    },
    admin_dashboard_review: {
        th: "รีวิว",
        en: "Reviews",
        ja: "レビュー",
    },
    admin_dashboard_articles: {
        th: "บทความ",
        en: "Articles",
        ja: "記事",
    },
    admin_dashboard_beauty_news: {
        th: "Beauty News",
        en: "Beauty News",
        ja: "Beauty News",
    },
    admin_dashboard_editorial_reviews: {
        th: "Editorial Reviews",
        en: "Editorial Reviews",
        ja: "Editorial Reviews",
    },
    admin_dashboard_expert_reviews: {
        th: "Expert Reviews",
        en: "Expert Reviews",
        ja: "Expert Reviews",
    },
    admin_dashboard_price_unset: {
        th: "ยังไม่ได้กำหนดราคา",
        en: "Price not set",
        ja: "価格未設定",
    },
    admin_dashboard_registrations: {
        th: "จำนวนลงทะเบียน",
        en: "Registrations",
        ja: "登録件数",
    },
    admin_dashboard_updates: {
        th: "จำนวนการอัปเดต",
        en: "Updates",
        ja: "更新件数",
    },
    admin_dashboard_likes: {
        th: "จำนวนไลก์",
        en: "Likes",
        ja: "いいね数",
    },
    admin_dashboard_reads: {
        th: "จำนวนการอ่าน",
        en: "Reads",
        ja: "既読数",
    },
    admin_dashboard_load_failed: {
        th: "โหลดข้อมูลแดชบอร์ดไม่สำเร็จ",
        en: "Failed to load dashboard data",
        ja: "ダッシュボードデータの読み込みに失敗しました",
    },
    admin_dashboard_logins: {
        th: "ผู้ใช้ที่เข้าสู่ระบบ",
        en: "Logins",
        ja: "ログインユーザ数",
    },
    admin_dashboard_search_keywords: {
        th: "คำค้นหายอดนิยม",
        en: "Search Keyword Ranking",
        ja: "検索キーワードランキング",
    },
    admin_dashboard_search_type_keyword: {
        th: "คำค้นหา",
        en: "Keyword search",
        ja: "キーワード検索",
    },
    admin_dashboard_search_type_category: {
        th: "หมวดหมู่",
        en: "Category filter",
        ja: "カテゴリ絞り込み",
    },
    admin_dashboard_search_type_brand: {
        th: "แบรนด์",
        en: "Brand filter",
        ja: "ブランド絞り込み",
    },
    admin_dashboard_search_type_product: {
        th: "สินค้า",
        en: "Product filter",
        ja: "商品絞り込み",
    },
    admin_dashboard_last_month: {
        th: "เดือนที่แล้ว",
        en: "Last month",
        ja: "前月",
    },
    admin_dashboard_months_ago: {
        th: "{{n}} เดือนที่แล้ว",
        en: "{{n}} months ago",
        ja: "{{n}}ヶ月前",
    },
    master_data_save_completed: {
        th: "บันทึกข้อมูลเรียบร้อยแล้ว",
        en: "Saved successfully",
        ja: "保存しました",
    },
    master_data_upload_completed: {
        th: "อัปโหลดเรียบร้อยแล้ว",
        en: "Uploaded successfully",
        ja: "アップロードしました",
    },
    master_data_product_updated: {
        th: "อัปเดตสินค้าเรียบร้อยแล้ว",
        en: "Product updated successfully",
        ja: "商品を更新しました",
    },
    master_data_product_deleted: {
        th: "ลบสินค้าเรียบร้อยแล้ว",
        en: "Product deleted successfully",
        ja: "商品を削除しました",
    },
    master_data_product_delete_confirm: {
        th: "ลบสินค้านี้หรือไม่?",
        en: "Delete this product?",
        ja: "この商品を削除しますか?",
    },
    master_data_delete_failed: {
        th: "ลบข้อมูลไม่สำเร็จ",
        en: "Failed to delete item",
        ja: "削除に失敗しました",
    },
    master_data_save_failed: {
        th: "บันทึกข้อมูลไม่สำเร็จ",
        en: "Failed to save item",
        ja: "保存に失敗しました",
    },
    master_data_upload_failed: {
        th: "อัปโหลดไม่สำเร็จ",
        en: "Failed to upload",
        ja: "アップロードに失敗しました",
    },
    master_data_url_empty: {
        th: "URL ว่างเปล่า",
        en: "URL is empty",
        ja: "URLが空です",
    },
    master_data_upload_endpoint_missing: {
        th: "ยังไม่ได้ตั้งค่า endpoint สำหรับอัปโหลด",
        en: "Upload endpoint is not configured",
        ja: "アップロードエンドポイントが設定されていません",
    },
    master_data_save_before_product_upload: {
        th: "กรุณาบันทึกสินค้าก่อน แล้วจึงอัปโหลดรูปภาพ",
        en: "Save the product first, then upload the image",
        ja: "先に商品を保存してから画像をアップロードしてください",
    },
    master_data_save_before_brand_upload: {
        th: "กรุณาบันทึกแบรนด์ก่อน แล้วจึงอัปโหลดรูปภาพ",
        en: "Save the brand first, then upload the image",
        ja: "先にブランドを保存してから画像をアップロードしてください",
    },
    master_data_select_image_first: {
        th: "กรุณาเลือกรูปภาพก่อน",
        en: "Select an image file first",
        ja: "先に画像ファイルを選択してください",
    },
    master_data_product_image_uploaded: {
        th: "อัปโหลดรูปภาพสินค้าเรียบร้อยแล้ว",
        en: "Product image uploaded successfully",
        ja: "商品画像をアップロードしました",
    },
    master_data_brand_updated: {
        th: "อัปเดตแบรนด์เรียบร้อยแล้ว",
        en: "Brand updated successfully",
        ja: "ブランドを更新しました",
    },
    master_data_brand_deleted: {
        th: "ลบแบรนด์เรียบร้อยแล้ว",
        en: "Brand deleted successfully",
        ja: "ブランドを削除しました",
    },
    master_data_brand_delete_confirm: {
        th: "ลบแบรนด์นี้หรือไม่? สินค้าและโพสต์ที่เกี่ยวข้องทั้งหมดจะถูกลบไปด้วย",
        en: "Delete this brand? Its products and posts will also be deleted.",
        ja: "このブランドを削除しますか?紐づく商品と投稿もすべて削除されます。",
    },
    master_data_user_updated: {
        th: "อัปเดตผู้ใช้เรียบร้อยแล้ว",
        en: "User updated successfully",
        ja: "ユーザーを更新しました",
    },
    master_data_user_deleted: {
        th: "ลบผู้ใช้เรียบร้อยแล้ว",
        en: "User deleted successfully",
        ja: "ユーザーを削除しました",
    },
    master_data_user_delete_confirm: {
        th: "ลบผู้ใช้นี้หรือไม่?",
        en: "Delete this user?",
        ja: "このユーザーを削除しますか?",
    },
    master_data_user_delete_failed: {
        th: "ลบผู้ใช้ไม่สำเร็จ",
        en: "Failed to delete user",
        ja: "ユーザーの削除に失敗しました",
    },
    master_data_user_update_failed: {
        th: "อัปเดตผู้ใช้ไม่สำเร็จ",
        en: "Failed to update user",
        ja: "ユーザーの更新に失敗しました",
    },
    users_admin_no_changes_to_save: {
        th: "ไม่มีการเปลี่ยนแปลงให้บันทึก",
        en: "No changes to save",
        ja: "保存する変更はありません",
    },
    category_review_editor_status_load_failed: {
        th: "โหลดข้อมูลไม่สำเร็จ",
        en: "Failed to load data",
        ja: "読み込みに失敗しました",
    },
    category_review_editor_status_parent_required: {
        th: "ชื่อหมวดหมู่หลักจำเป็นต้องกรอก (ID: {{parentId}})",
        en: "Parent category name is required (ID: {{parentId}})",
        ja: "親カテゴリ名は必須です (ID: {{parentId}})",
    },
    category_review_editor_status_no_changes: {
        th: "ไม่มีการเปลี่ยนแปลง",
        en: "No changes",
        ja: "変更はありません",
    },
    category_review_editor_status_category_saved: {
        th: "บันทึกหมวดหมู่แล้ว ({{count}} รายการ)",
        en: "Categories saved ({{count}})",
        ja: "カテゴリを保存しました ({{count}}件)",
    },
    category_review_editor_status_category_save_failed: {
        th: "บันทึกหมวดหมู่ไม่สำเร็จ",
        en: "Failed to save categories",
        ja: "カテゴリ保存に失敗しました",
    },
    category_review_editor_status_review_config_saved: {
        th: "บันทึกการตั้งค่ารีวิวแล้ว ({{count}} รายการ)",
        en: "Review configs saved ({{count}})",
        ja: "レビュー設定を保存しました ({{count}}件)",
    },
    category_review_editor_status_review_config_save_failed: {
        th: "บันทึกการตั้งค่ารีวิวไม่สำเร็จ",
        en: "Failed to save review configs",
        ja: "レビュー設定の保存に失敗しました",
    },
    category_review_editor_status_saved_changes: {
        th: "บันทึกการเปลี่ยนแปลงแล้ว ({{count}} รายการ)",
        en: "Saved changes ({{count}})",
        ja: "変更を保存しました ({{count}}件)",
    },
    category_review_editor_review_config_allocate_failed: {
        th: "ไม่สามารถจัดสรร review config ID ได้",
        en: "Failed to allocate review config ID",
        ja: "review config ID の割り当てに失敗しました",
    },
    category_review_editor_status_question_saved: {
        th: "บันทึกคำถามแล้ว ({{count}} รายการ)",
        en: "Questions saved ({{count}})",
        ja: "質問を保存しました ({{count}}件)",
    },
    category_review_editor_status_question_save_failed: {
        th: "บันทึกคำถามไม่สำเร็จ",
        en: "Failed to save questions",
        ja: "質問保存に失敗しました",
    },
    search_advanced_tabs: {
        th: "แท็บเป้าหมายการค้นหา",
        en: "Search target tabs",
        ja: "検索対象タブ",
    },
    search_filter_by_category: {
        th: "กรองตามหมวดหมู่",
        en: "Filter by Category",
        ja: "カテゴリで絞り込み",
    },
    search_popular_brands: {
        th: "แบรนด์ยอดนิยม",
        en: "Popular Brands",
        ja: "人気ブランド",
    },
    search_brand_search: {
        th: "แบรนด์",
        en: "Brand",
        ja: "ブランド",
    },
    search_user_search: {
        th: "ค้นหาผู้ใช้",
        en: "User Search",
        ja: "ユーザー検索",
    },
    search_review_user_search: {
        th: "ค้นหาผู้ใช้รีวิว",
        en: "Review User Search",
        ja: "レビュー投稿ユーザー検索",
    },
    search_product_update_user_search: {
        th: "ค้นหาผู้ใช้อัปเดตสินค้า",
        en: "Product Update User Search",
        ja: "商品更新ユーザー検索",
    },
    search_user: {
        th: "ค้นหาผู้ใช้:",
        en: "Search User:",
        ja: "ユーザー検索:",
    },
    search_user_placeholder: {
        th: "ค้นหาผู้ใช้...",
        en: "Search users...",
        ja: "ユーザーを検索...",
    },
    search_all_brands: {
        th: "แบรนด์ทั้งหมด",
        en: "All Brands",
        ja: "すべてのブランド",
    },
    show_all: {
        th: "แสดงทั้งหมด",
        en: "Show all",
        ja: "全て表示",
    },
    select_brand: {
        th: "เลือกแบรนด์...",
        en: "Select brand...",
        ja: "ブランドを選択...",
    },
    select_user: {
        th: "เลือกผู้ใช้...",
        en: "Select user...",
        ja: "ユーザーを選択...",
    },
    search_popular_products: {
        th: "สินค้ายอดนิยม",
        en: "Popular Products",
        ja: "人気商品",
    },
    search_popular_keywords: {
        th: "คำค้นหายอดนิยม",
        en: "Popular Keywords",
        ja: "人気キーワード",
    },
    search_recommended: {
        th: "แนะนำ",
        en: "Recommended",
        ja: "おすすめ",
    },
    recommend: {
        th: "แนะนำ",
        en: "Recommend",
        ja: "おすすめ",
    },
    products_from: {
        th: "สินค้าจาก",
        en: "Products from",
        ja: "〜の製品",
    },
    search_no_categories: {
        th: "ไม่มีหมวดหมู่",
        en: "No categories available",
        ja: "カテゴリがありません",
    },
    search_no_brands: {
        th: "ไม่มีแบรนด์",
        en: "No brands available",
        ja: "ブランドがありません",
    },
    search_no_users: {
        th: "ไม่มีผู้ใช้",
        en: "No users available",
        ja: "ユーザーがありません",
    },
    search_no_products: {
        th: "ไม่มีสินค้า",
        en: "No products available",
        ja: "商品がありません",
    },
    search_no_keywords: {
        th: "ไม่มีคำค้นหา",
        en: "No keywords available",
        ja: "キーワードがありません",
    },
    login_required: {
        th: "ต้อง",
        en: "Please",
        ja: "ログインが",
    },
    login_redirect_to_intended: {
        th: "หลังจากเข้าสู่ระบบ คุณจะถูกเปลี่ยนเส้นทางไปยังหน้าที่ร้องขอ",
        en: "After login, you will be redirected to the requested page",
        ja: "ログイン後、元のページに戻ります",
    },
    login_redirect_to_last: {
        th: "หลังจากเข้าสู่ระบบ คุณจะถูกเปลี่ยนเส้นทางไปยังหน้าก่อนหน้านี้",
        en: "After login, you will be redirected to your last visited page",
        ja: "ログイン後、前回訪問したページに戻ります",
    },
    // Authentication form labels
    email_address: {
        th: "อีเมล",
        en: "Email",
        ja: "メールアドレス",
    },
    password: {
        th: "รหัสผ่าน",
        en: "Password",
        ja: "パスワード",
    },
    forgot_password: {
        th: "ลืมรหัสผ่าน?",
        en: "Forgot password?",
        ja: "パスワードを忘れた方",
    },
    password_reminder_title: {
        th: "รีมายด์รหัสผ่าน",
        en: "Password Reminder",
        ja: "パスワードリマインダー",
    },
    password_reminder_if_registered: {
        th: "หากอีเมลนี้ลงทะเบียนไว้ ระบบได้ส่งอีเมลรีมายด์เรียบร้อยแล้ว",
        en: "If this email is registered, a password reminder email has been sent.",
        ja: "このメールアドレスが登録済みの場合、パスワードリマインドメールを送信しました。",
    },
    password_reminder_email_not_found: {
        th: "ไม่พบอีเมลที่ระบุในระบบ",
        en: "The specified email address is not registered.",
        ja: "指定されたメールアドレスは登録されていません。",
    },
    password_change_completed: {
        th: "อัปเดตรหัสผ่านเรียบร้อยแล้ว",
        en: "Password updated successfully.",
        ja: "パスワードを更新しました。",
    },
    send: {
        th: "ส่ง",
        en: "Send",
        ja: "送信",
    },
    password_change_required_title: {
        th: "เปลี่ยนรหัสผ่าน",
        en: "Change Password",
        ja: "パスワード変更",
    },
    password_change_tab: {
        th: "เปลี่ยนรหัสผ่าน",
        en: "Change Password",
        ja: "パスワード変更",
    },
    password_change_required_caption: {
        th: "คุณกำลังเข้าสู่ระบบด้วยรหัสผ่านชั่วคราว กรุณาเปลี่ยนรหัสผ่านใหม่ก่อนดำเนินการต่อ",
        en: "You are logged in with a temporary password. Please set a new password before continuing.",
        ja: "仮パスワードでログインしています。続行するには新しいパスワードへ変更してください。",
    },
    current_password_temp: {
        th: "รหัสผ่านปัจจุบัน (รหัสผ่านชั่วคราว)",
        en: "Current Password (Temporary Password)",
        ja: "現在のパスワード（仮パスワード）",
    },
    new_password: {
        th: "รหัสผ่านใหม่",
        en: "New Password",
        ja: "新しいパスワード",
    },
    new_password_confirmation: {
        th: "ยืนยันรหัสผ่านใหม่",
        en: "Confirm New Password",
        ja: "新しいパスワード（確認）",
    },
    password_policy_hint: {
        th: "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร",
        en: "Password must be at least 8 characters.",
        ja: "パスワードは8文字以上にしてください。",
    },
    password_change_email_notice_hint: {
        th: "เมื่อบันทึกสำเร็จ ระบบจะส่งอีเมลแจ้งรหัสผ่านใหม่ไปยังอีเมลที่ลงทะเบียนไว้",
        en: "After saving, the new password will be emailed to the registered address.",
        ja: "保存すると、登録済みのメールアドレスへ新しいパスワードが記載されたメールが送信されます。",
    },
    password_confirmation_mismatch: {
        th: "การยืนยันรหัสผ่านไม่ตรงกัน",
        en: "Password confirmation does not match.",
        ja: "パスワード確認が一致しません。",
    },
    password_form_validation_failed: {
        th: "ตรวจสอบฟอร์มรหัสผ่านไม่สำเร็จ",
        en: "Failed to validate password form",
        ja: "パスワードフォームの検証に失敗しました",
    },
    password_update_failed: {
        th: "อัปเดตรหัสผ่านไม่สำเร็จ",
        en: "Failed to update password",
        ja: "パスワードの更新に失敗しました",
    },

    registration_email_sent: {
        th: "ส่งอีเมลยืนยันเรียบร้อยแล้ว",
        en: "Registration email sent.",
        ja: "確認メールを送信しました。",
    },
    registration_email_sent_check: {
        th: "ส่งอีเมลยืนยันไปที่ {{email}} แล้ว กรุณาตรวจสอบกล่องจดหมายของคุณ",
        en: "We sent a verification email to {{email}}. Please check your inbox.",
        ja: "確認メールを{{email}}に送信しました。受信箱をご確認ください。",
    },
    registration_email_sent_check_no_email: {
        th: "ส่งอีเมลยืนยันแล้ว กรุณาตรวจสอบกล่องจดหมายของคุณ",
        en: "We sent a verification email. Please check your inbox.",
        ja: "確認メールを送信しました。受信箱をご確認ください。",
    },
    registration_verify_success: {
        th: "ยืนยันอีเมลสำเร็จ การสมัครสมาชิกเสร็จสมบูรณ์แล้ว",
        en: "Email verified. Registration completed.",
        ja: "メール認証が完了しました。登録が完了しました。",
    },
    registration_verify_failed: {
        th: "การยืนยันอีเมลไม่สำเร็จ",
        en: "Email verification failed.",
        ja: "メール認証に失敗しました。",
    },
    registration_verify_not_found: {
        th: "ไม่พบลิงก์ยืนยัน หรือหมดอายุแล้ว",
        en: "Verification link not found or expired.",
        ja: "確認リンクが見つからないか、期限切れです。",
    },
    registration_failed: {
        th: "การสมัครสมาชิกไม่สำเร็จ",
        en: "Registration failed.",
        ja: "登録に失敗しました。",
    },

    registration_request_failed: {
        th: "ส่งอีเมลยืนยันไม่สำเร็จ",
        en: "Failed to send registration email.",
        ja: "確認メールの送信に失敗しました。",
    },

    email_already_registered: {
        th: "อีเมลนี้ถูกใช้ลงทะเบียนแล้ว",
        en: "This email is already registered.",
        ja: "このメールアドレスはすでに登録されています。",
    },

    age_not_registered: {
        th: "ไม่ได้ระบุอายุ",
        en: "Age not provided",
        ja: "年齢未登録",
    },
    login: {
        th: "เข้าสู่ระบบ",
        en: "Login",
        ja: "ログイン",
    },
    go_to_login: {
        th: "ไปที่หน้าเข้าสู่ระบบ",
        en: "Go to login",
        ja: "ログインへ",
    },
    logout: {
        th: "ออกจากระบบ",
        en: "Logout",
        ja: "ログアウト",
    },
    language: {
        th: "ภาษา",
        en: "Language",
        ja: "言語",
    },
    connect: {
        th: "เชื่อมต่อ",
        en: "Connect",
        ja: "連携",
    },
    disconnect: {
        th: "ยกเลิก",
        en: "Disconnect",
        ja: "解除",
    },
    login_with_facebook: {
        th: "เข้าสู่ระบบด้วย Facebook",
        en: "Login with Facebook",
        ja: "Facebookでログイン",
    },
    or_login_with: {
        th: "หรือเข้าสู่ระบบด้วย",
        en: "or login with",
        ja: "または次でログイン",
    },
    login_mobile_qr_title: {
        th: "เข้าสู่ระบบบนมือถือ",
        en: "Login on mobile",
        ja: "スマホでログイン",
    },
    login_mobile_qr_description: {
        th: "สแกน QR นี้เพื่อเปิดหน้าล็อกอินเดียวกันบนมือถือ",
        en: "Scan this QR code to open the same login page on your phone.",
        ja: "このQRコードを読み取ると、同じログイン画面をスマホで開けます。",
    },
    login_mobile_qr_hint: {
        th: "หากมีปลายทางหลังล็อกอิน ระบบจะพาไปต่อบนมือถือด้วย",
        en: "If a post-login destination is set, the same redirect target is kept on mobile.",
        ja: "ログイン後の遷移先がある場合も、そのままスマホ側へ引き継がれます。",
    },
    login_mobile_qr_link: {
        th: "เปิด URL ล็อกอิน",
        en: "Open login URL",
        ja: "ログインURLを開く",
    },
    // Iframe authentication
    authentication_required: {
        th: "จำเป็นต้องเข้าสู่ระบบ",
        en: "Authentication Required",
        ja: "認証が必要です",
    },
    network_connection_failed: {
        th: "การเชื่อมต่อเครือข่ายล้มเหลว",
        en: "Network connection failed",
        ja: "ネットワーク接続に失敗しました",
    },
    like_update_failed: {
        th: "อัปเดตการถูกใจไม่สำเร็จ",
        en: "Failed to update like",
        ja: "いいねの更新に失敗しました",
    },
    like_post_failed: {
        th: "กดถูกใจโพสต์ไม่สำเร็จ",
        en: "Failed to like post",
        ja: "投稿へのいいねに失敗しました",
    },
    unlike_post_failed: {
        th: "ยกเลิกถูกใจโพสต์ไม่สำเร็จ",
        en: "Failed to unlike post",
        ja: "投稿のいいね解除に失敗しました",
    },
    like_comment_failed: {
        th: "กดถูกใจคอมเมนต์ไม่สำเร็จ",
        en: "Failed to like comment",
        ja: "コメントへのいいねに失敗しました",
    },
    unlike_comment_failed: {
        th: "ยกเลิกถูกใจคอมเมนต์ไม่สำเร็จ",
        en: "Failed to unlike comment",
        ja: "コメントのいいね解除に失敗しました",
    },
    login_required_message: {
        th: "กรุณาเข้าสู่ระบบเพื่อดำเนินการต่อ",
        en: "Please login to continue to the requested page.",
        ja: "続行するにはログインしてください。",
    },
    login_in_new_window: {
        th: "เข้าสู่ระบบในหน้าต่างใหม่",
        en: "Login in New Window",
        ja: "新しいウィンドウでログイン",
    },
    iframe_login_info: {
        th: "หน้าเข้าสู่ระบบจะเปิดในหน้าต่างหลัก",
        en: "The login page will open in the main window.",
        ja: "ログインページはメインウィンドウで開きます。",
    },
    // Time/Date related
    posted_on: {
        th: "โพสต์เมื่อ",
        en: "Posted on",
        ja: "投稿日時",
    },
    updated_on: {
        th: "อัปเดตเมื่อ",
        en: "Updated on",
        ja: "更新日時",
    },
    created_date: {
        th: "วันที่สร้าง",
        en: "Created on",
        ja: "作成日",
    },
    // Actions
    share: {
        th: "แชร์",
        en: "Share",
        ja: "シェア",
    },
    report: {
        th: "รายงาน",
        en: "Report",
        ja: "報告",
    },
    bookmark: {
        th: "บุ๊กมาร์ก",
        en: "Bookmark",
        ja: "ブックマーク",
    },
    reply: {
        th: "ตอบกลับ",
        en: "Reply",
        ja: "返信",
    },
    untitled: {
        th: "ไม่มีชื่อ",
        en: "Untitled",
        ja: "無題",
    },
    "all-rights-reserved": {
        th: "All rights reserved",
        en: "All rights reserved",
        ja: "All rights reserved",
    },
    // Spinner system and operation status translations
    spinner_proccesing: {
        th: "",
        en: "",
        ja: "",
    },
    wysiwyg_tiktok_embed_converted: {
        th: "ระบบแปลงโค้ดฝัง TikTok เป็นลิงก์แล้ว",
        en: "Converted TikTok embed code to a link.",
        ja: "TikTok埋め込みコードをリンクに変換しました。",
    },
    wysiwyg_tiktok_embed_detected: {
        th: "ตรวจพบโค้ดฝัง TikTok",
        en: "Detected TikTok embed code.",
        ja: "TikTok埋め込みコードを検出しました。",
    },
    wysiwyg_tiktok_embed_inserted: {
        th: "แทรกการฝัง TikTok แล้ว",
        en: "Inserted TikTok embed.",
        ja: "TikTok埋め込みを挿入しました。",
    },
    deleting: {
        th: "กำลังลบ...",
        en: "Deleting...",
        ja: "削除中...",
    },
    loading: {
        th: "กำลังโหลด...",
        en: "Loading...",
        ja: "読込中...",
    },
    loading_page: {
        th: "กำลังโหลดหน้า...",
        en: "Loading page...",
        ja: "ページを読み込んでいます...",
    },
    submitting: {
        th: "กำลังส่งข้อมูล...",
        en: "Submitting data...",
        ja: "データを送信中...",
    },
    uploading: {
        th: "กำลังอัปโหลด...",
        en: "Uploading...",
        ja: "アップロード中...",
    },
    content_placeholder: {
        th: "เขียนข้อความที่นี่...",
        en: "Write your content here...",
        ja: "ここに内容を入力してください...",
    },
    clear_filters: {
        th: "ล้างตัวกรอง",
        en: "Clear",
        ja: "クリア",
    },
    filter_sidebar_search_placeholder: {
        th: "ค้นหา...",
        en: "Search...",
        ja: "検索...",
    },
};

export { dictUI };
